import { create } from 'zustand'

export type StreamGoalResponse = {
  stream_id: string
  user_id: string
  goal_id?: string
  amount_goal: number | null
  amount_tipped: number
  remaining: number | null
  percent: number | null
  reward?: string | null
  public?: boolean
  completed?: boolean
}

interface ViewerStore {
  playing: boolean
  muted: boolean
  commentsShown: boolean
  streamId: string | null
  currentStreamGoal: StreamGoalResponse | null
  viewerCount: number
  showTips: boolean
  tipsAmount: number

  setShowTips: (value: boolean) => void
  setTipsAmount: (amount: number) => void
  incrementTipsAmount: (amount: number) => void
  clearTipsAmount: () => void

  mute: () => void
  unmute: () => void
  toggleComments: () => void
  setPlaying: (playing: boolean) => void
  setStreamId: (streamId: string | null) => void
  clearStreamId: () => void

  setCurrentStreamGoal: (goal: StreamGoalResponse | null) => void
  clearCurrentStreamGoal: () => void

  setViewerCount: (count: number) => void
  incrementViewerCount: () => void
  decrementViewerCount: () => void
  clearViewerCount: () => void
}

export const useViewerStore = create<ViewerStore>()(set => ({
  playing: true,
  muted: true,
  commentsShown: false,
  streamId: null,
  currentStreamGoal: null,
  viewerCount: 0,
  showTips: false,
  tipsAmount: 0,

  setShowTips: (value: boolean) => set({ showTips: value }),

  setTipsAmount: (amount: number) =>
    set({ tipsAmount: Number.isFinite(amount) ? Math.max(0, amount) : 0 }),

  incrementTipsAmount: (amount: number) =>
    set(state => ({
      tipsAmount:
        Number.isFinite(amount) && amount > 0
          ? state.tipsAmount + amount
          : state.tipsAmount,
    })),

  clearTipsAmount: () => set({ tipsAmount: 0 }),

  mute: () => set({ muted: true }),
  unmute: () => set({ muted: false }),

  toggleComments: () =>
    set(state => ({
      commentsShown: !state.commentsShown,
    })),

  setPlaying: (playing: boolean) => set({ playing }),
  setStreamId: (streamId: string | null) => set({ streamId }),
  clearStreamId: () => set({ streamId: null }),

  setCurrentStreamGoal: (goal: StreamGoalResponse | null) =>
    set({ currentStreamGoal: goal }),
  clearCurrentStreamGoal: () => set({ currentStreamGoal: null }),

  setViewerCount: (count: number) =>
    set({ viewerCount: Number.isFinite(count) ? Math.max(0, count) : 0 }),

  incrementViewerCount: () =>
    set(state => ({
      viewerCount: state.viewerCount + 1,
    })),

  decrementViewerCount: () =>
    set(state => ({
      viewerCount: Math.max(0, state.viewerCount - 1),
    })),

  clearViewerCount: () => set({ viewerCount: 0 }),
}))